import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { clearAllCoreFacets, deleteAllCoreFacets, deselectAllValuesInCoreFacet, updateAutoSelectionForAllCoreFacets, updateCoreFacetFreezeCurrentValues, updateCoreFacetIsFieldExpanded, updateCoreFacetNumberOfValues, } from './core-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available core facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the core facet action creators.
 *
 * @group Actions
 * @category CategoryFacet
 */
export function loadCoreFacetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        clearAllCoreFacets,
        deleteAllCoreFacets,
        deselectAllValuesInCoreFacet,
        updateAutoSelectionForAllCoreFacets,
        updateCoreFacetFreezeCurrentValues,
        updateCoreFacetIsFieldExpanded,
        updateCoreFacetNumberOfValues,
    };
}
